import { useQuery } from 'react-query';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { dateToISO8601 } from '../helpers/dates';
import { PerformancePeriodDTO } from '../types';

interface IncomeDetailsBaseDTO {
  name: string;
  marketValue: number;
  allocation: number;
  annualIncomeRate: number;
  estimatedAnnualIncome: number;
  currentYield: number;
  yieldOnCost: number;
}

export interface IncomeDetailsRowDTO extends IncomeDetailsBaseDTO {
  ticker: string | null;
  units: number;
  price: number | null;
}

export interface IncomeDetailsGroupDTO extends IncomeDetailsBaseDTO {
  color: string | null;
  rows: IncomeDetailsRowDTO[];
}

interface IncomeDetailsCategoryDTO {
  name: string;
  groups: IncomeDetailsGroupDTO[];
}

interface IncomeDetailsDTO {
  categories: IncomeDetailsCategoryDTO[];
  defaultGroup: string;
}

interface FetcherParams {
  clientId: number;
  period?: PerformancePeriodDTO;
  startDate?: string;
  endDate?: string;
  accountId: string;
  groupId: string;
}

const fetchIncomeDetails = ({
  clientId,
  period,
  startDate,
  endDate,
  accountId,
  groupId,
}: FetcherParams): Promise<IncomeDetailsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OrionAccountsWidgets/IncomeDetails', {
      clientId,
      period,
      startDate,
      endDate,
      accountId,
      groupId,
      localDate: dateToISO8601(),
    }),
  );
};

interface QueryParams {
  period?: PerformancePeriodDTO;
  startDate?: string;
  endDate?: string;
  accountId: string;
  groupId: string;
}

export const useIncomeDetailsQuery = ({
  period,
  startDate: _startDate,
  endDate: _endDate,
  accountId,
  groupId,
}: QueryParams) => {
  const clientId = useClientId();
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  return useQuery(
    queryKeys.incomeDetails(clientId, period, startDate, endDate, accountId, groupId),

    () => fetchIncomeDetails({ clientId, period, startDate, endDate, accountId, groupId }),
  );
};
